import script from "./SidenavItem.vue?vue&type=script&setup=true&lang=js"
export * from "./SidenavItem.vue?vue&type=script&setup=true&lang=js"

import "./SidenavItem.vue?vue&type=style&index=0&id=a4a760be&lang=scss&scoped=true"

import exportComponent from "/builds/p3839/client-suite/proxima_blue2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a4a760be"]])

export default __exports__